import PropTypes from 'prop-types';

import BrLoader from '@components/BrLoader';
import BrBottomNav from './components/BrBottomNav';
import BrVerticalStepper from './components/BrVerticalStepper';
import { isFirstWorkflowStep, isLastWorkflowStep, getActiveStepDetail } from './BrWorkflow-utils';
import './brWorkflow.scss';

export default function BrWorkflow(props) {
  const {
    workflowSteps,
    activeStepIndex,
    disableContinue,
    disableBack,
    isLoading,
    onContinueClick,
    onBackClick,
    onCancelClick,
  } = props;

  const activeStepDetail = getActiveStepDetail(workflowSteps, activeStepIndex);
  const { component: Content, componentProps, customButtons, loadingMsg } = activeStepDetail;
  const isLastStep = isLastWorkflowStep(workflowSteps, activeStepIndex);
  const isFirstStep = isFirstWorkflowStep(workflowSteps, activeStepIndex);

  return (
    <div className="workflow-container">
      <div className="workflow-stepnav-container">
        <BrVerticalStepper workflowSteps={workflowSteps} activeStepIndex={activeStepIndex} nestingLevel={1} />
      </div>
      <div className="workflow-content-bottomnav-wrapper">
        <div className="workflow-content-container">
          {isLoading ? (
            <BrLoader loadingMsg={loadingMsg} className="workflow-content-loading" />
          ) : (
            <Content {...componentProps} />
          )}
        </div>
        <BrBottomNav
          showContinue={!isLastStep}
          showBack={!isFirstStep}
          disableContinue={disableContinue}
          disableBack={disableBack}
          customButtons={customButtons}
          onContinueClick={onContinueClick}
          onBackClick={onBackClick}
          onCancelClick={onCancelClick}
          workflowSteps={workflowSteps}
          activeStepIndex={activeStepIndex}
        />
      </div>
    </div>
  );
}

BrWorkflow.propTypes = {
  workflowSteps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      component: PropTypes.elementType,
      componentProps: PropTypes.object,
      loadingMsg: PropTypes.string,
      customButtons: PropTypes.arrayOf(PropTypes.object), // each item of array will be used as prop for a BrButton
      subSteps: PropTypes.shape({
        workflowSteps: PropTypes.arrayOf(PropTypes.object).isRequired,
        activeStepIndex: PropTypes.number,
        loadingMsg: PropTypes.string,
      }),
    }),
  ),
  activeStepIndex: PropTypes.number.isRequired,
  disableContinue: PropTypes.bool,
  disableBack: PropTypes.bool,
  onContinueClick: PropTypes.func,
  onBackClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  isLoading: PropTypes.bool,
};
